export const updateOrderAccess = async ({ BeURL, id, accessGranted, expiresAt }) => {
    try {
        const res = await fetch(`${BeURL}/update-order-access/${id}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ accessGranted, expiresAt }),
        });

        return await res.json();
    } catch (err) {
        console.error(err);
        return null;
    }
};